import { StyledRoleBadge } from './styled';
export function UserBadge(props) {
    const { id } = props;
    return <StyledRoleBadge id={id}/>;
}
